import { ColorItemSchemeClass } from '../theme.const';
import { FilterState, FilterView, ToolbarFilterOption, ToolBarViewOption } from './filters-toolbar.model';

// TODO: dynamically generate space area and space area uom
export const DEFAULT_NA_FILTER_OPTION: ToolbarFilterOption = {
  id: 0,
  label: 'filters.notApplicable',
  spaceArea: 0,
  spaceAreaUOM: '',
  class: ColorItemSchemeClass.ExpireNA,
  spaces: null,
  key: 'filters.notApplicable',
};

export const DEFAULT_UN_FILTER_OPTION: ToolbarFilterOption = {
  id: 0,
  label: 'filters.unaccounted',
  spaceArea: 0,
  spaceAreaUOM: '',
  class: ColorItemSchemeClass.ExpireUnaccounted,
  spaces: null,
  key: 'filters.unaccounted',
};

export const DEFAULT_VIEW_OPTIONS: ToolBarViewOption[] = [
  { key: FilterView.LeaseYear, value: 'filters.leaseExpiryYear' }, // Lease End Year
  { key: FilterView.Occupiers, value: 'filters.occupier' }, // Tenants
  { key: FilterView.Industry, value: 'filters.industry' }, // Industry (NAICS code)
  { key: FilterView.Lease, value: 'filters.leaseExpiry' }, // Lease End by Date Range
];

export const DEFAULT_FILTER_STATE: FilterState = {
  viewBy: FilterView.LeaseYear,
  selectedFilters: {},
  filterOptions: null,
};
